module.exports = __webpack_public_path__ + "static/media/niezbednik_01_A.eea66723.png";